import React from 'react';
export function MobileApp() {
  return <section className="py-24 px-6 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16" data-id="element-165">
      <div className="flex-1 text-center md:text-left" data-id="element-166">
        {/* Style 3 — card heading black, used for smaller section heading */}
        <h2 className="text-card-heading !text-[40px] !leading-[44px] md:!text-[50px] md:!leading-[54px] mb-6 font-[500]" data-id="element-167">
          Tu negocio en tu bolsillo.
        </h2>
        {/* Style 1 — body text */}
        <p className="text-body !text-gray-600 mb-8 max-w-md mx-auto md:mx-0" data-id="element-168">
          No esperes a llegar a la oficina para cerrar ese trato. Con la App,
          gestiona leads, responde Mensajes en el chat y supervisa tus embudos
          en tiempo real, estés donde estés.
        </p>
        <a href="#" className="text-[#F77730] font-semibold hover:underline inline-flex items-center gap-2 text-[18px]" data-id="element-169">
          Ver App →
        </a>
      </div>

      <div className="flex-1 flex flex-col sm:flex-row justify-center md:justify-end items-center gap-8 relative" data-id="element-170">
        {/* Phone Image */}
        <img src="https://cdn.magicpatterns.com/uploads/hpq7ssRf4mMspCcyoLSFzC/Captura_de_pantalla_2026-04-08_130245.png" alt="Valuan CRM App con App Store y Google Play" className="w-[416px] md:w-[624px] h-auto object-contain" data-id="element-171" />
      </div>
    </section>;
}